import { z } from 'zod'

export const toastContainerSchema = z.enum([
  'FOLLOW_UP',
  'GLOBAL',
  'COMPANIES',
  'WORKSPACE_SELECT',
  'WORKSPACE_SETTINGS',
  'COMPANY_SETTINGS',
  'COMPANY_MEMBERS',
  'PROJECTS',
  'BOT_SELECT',
  'BOT_LAYOUT',
  'BOT_MEMBERS',
  'CAMPAIGN_MODULE',
  'CAMPAIGN_MODULE_TEMPLATES',
  'CAMPAIGN_MODULE_ACTIONINGS',
  'CAMPAIGN_MODULE_CAMPAIGNS',
  'BUILDER',
  'CONVERSATION_HISTORY',
  'KNOWLEDGE_BASE',
  'INTEGRATIONS',
  'BUBBLE',
  'BUBBLE_AGENTS',
  'BUBBLE_TASKS',
  'BOT_THEME',
  'CAMPAIGN_DISPATCHES',
])

export type ToastContainerEnum = z.infer<typeof toastContainerSchema>
